var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmulator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-emulator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-emulator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uE236",
    transform: "translate(3.000000, 4.375000)",
    fill: "#0B94BC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78125,4.1484375 L8.15625,7.2421875 C8.34375,7.4296875 8.4375,7.640625 8.4375,7.875 C8.4375,8.109375 8.34375,8.3203125 8.15625,8.5078125 L4.78125,11.6015625 C4.3828125,11.8828125 3.984375,11.859375 3.5859375,11.53125 C3.28125,11.1328125 3.3046875,10.734375 3.65625,10.3359375 L6.36328125,7.875 L3.65625,5.4140625 C3.3046875,5.015625 3.28125,4.6171875 3.5859375,4.21875 C3.984375,3.8671875 4.3828125,3.84375 4.78125,4.1484375 L4.78125,4.1484375 Z M13.78125,10.6875 C14.296875,10.734375 14.578125,11.015625 14.625,11.53125 C14.578125,12.046875 14.296875,12.328125 13.78125,12.375 L8.71875,12.375 C8.203125,12.328125 7.921875,12.046875 7.875,11.53125 C7.921875,11.015625 8.203125,10.734375 8.71875,10.6875 L13.78125,10.6875 Z M15.75,0 C16.3828125,0.0234375 16.9101562,0.24609375 17.3320312,0.66796875 L17.3320312,0.66796875 C17.7539062,1.08984375 17.9765625,1.6171875 18,2.25 L18,13.5 C17.9765625,14.1328125 17.7539062,14.6601562 17.3320312,15.0820312 C16.9101562,15.5039062 16.3828125,15.7265625 15.75,15.75 L2.25,15.75 C1.6171875,15.7265625 1.08984375,15.5039062 0.66796875,15.0820312 C0.24609375,14.6601562 0.0234375,14.1328125 0,13.5 L0,2.25 C0.0234375,1.6171875 0.24609375,1.08984375 0.66796875,0.66796875 C1.08984375,0.24609375 1.6171875,0.0234375 2.25,0 L15.75,0 Z M15.75,1.6875 L2.25,1.6875 C1.8984375,1.7109375 1.7109375,1.8984375 1.6875,2.25 L1.6875,13.5 C1.7109375,13.8515625 1.8984375,14.0390625 2.25,14.0625 L15.75,14.0625 C16.1015625,14.0390625 16.2890625,13.8515625 16.3125,13.5 L16.3125,2.25 C16.2890625,1.8984375 16.1015625,1.7109375 15.75,1.6875 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmulator);
export default __webpack_public_path__ + "static/media/ic-emulator.320012471a5915c9dc05657f2f7ebbe7.svg";
export { ForwardRef as ReactComponent };